<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>账户管理</el-breadcrumb-item>
      <el-breadcrumb-item>交易记录</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search" @submit.native.prevent>
      <el-form-item label="搜索：">
        <el-select size="small" v-model="formInline.isRecharge" placeholder="选择类型" style="width: 150px;"
          @keyup.enter.native="search">
          <el-option v-for="type in payType" :label="type.lable" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input v-model="formInline.appletUserName" size="small" placeholder="请输入用户名"></el-input>
      </el-form-item>

      <el-form-item v-if="user.username == 'admin'" label="选择部门">
        <el-select v-model="formInline.depId" placeholder="请选择部门" size="small">
          <el-option v-for="item in deptList" :key="item.id" :label="item.departmentName" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>


      <el-form-item>
        <div style="position: relative;top: 1px;">
          <el-date-picker size="small" v-model="dataStr" type="daterange" range-separator="至" start-placeholder="开始日期"
            @change="getDate" end-placeholder="结束日期">
          </el-date-picker>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <!-- <el-button size="small"  type="success" icon="el-icon-download" :loading="downloadLoadin" @click="exportdata">账单导出</el-button>-->
        <el-button size="small" type="success" icon="el-icon-download" :loading="downloadJlLoadin" @click="exportJldata">交易记录导出</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->



    <!-- <el-button size="small" type="primary" :disabled="prints.length == 0" style="margin-bottom: 6px;" @click="handlePrint">批量打印收据</el-button> -->
    <prems-button type="primary" size="small" :disabled="prints.length == 0" @click="handlePrint" style="margin-bottom: 6px;"  perms="account:download"  label="批量打印收据" />



    <el-table :header-cell-style="this.$store.state.headerCss" size="small" :data="listData" highlight-current-row
      v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" stripe :max-height="tableHeight"
      @selection-change="selectionChange">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>

      <el-table-column prop="appletName" label="用户账号" width="160" sortable show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="money" label="交易金额" width="120" sortable show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="createDate" label="创建时间" width="160" show-overflow-tooltip>
      </el-table-column>
      <el-table-column label="计量点">
        <template slot-scope="scope">
          <!-- <p v-for="item in scope.row.meterInfoNames"> <el-tag size="mini" >{{item}}</el-tag></p> -->
          <el-tag size="mini" style="margin-right: 4px;margin-bottom: 5px;" v-for="item in scope.row.meterInfoNames">{{item}}</el-tag>

        </template>
      </el-table-column>



      <el-table-column prop="mark" label="备注" show-overflow-tooltip width="160">
      </el-table-column>

      <el-table-column label="支付方式" width="120" show-overflow-tooltip v-if="!showJ">
        <template slot-scope="scope">
          <span v-if="scope.row.transType == 8">多还少补</span>
          <span v-if="scope.row.transType == 7">其他</span>
          <span v-if="scope.row.transType == 6">微信小程序</span>
          <span v-if="scope.row.transType == 5">微信</span>
          <span v-if="scope.row.transType == 4">支付宝</span>
          <span v-if="scope.row.transType == 3">POS</span>
          <span v-if="scope.row.transType == 2">转账</span>
          <span v-if="scope.row.transType == 1">现金</span>
        </template>
      </el-table-column>
      <el-table-column prop="transType" label="交易类型" width="120" show-overflow-tooltip>
        <template slot-scope="scope">
          <!-- {{scope.row.isRecharge == 3}} -->
          <span v-if="scope.row.isRecharge == 1">充值</span>
          <span v-if="scope.row.isRecharge == 2">扣费</span>
          <span v-if="scope.row.isRecharge == 3">退款</span>
        </template>
      </el-table-column>
      <el-table-column prop="transType" label="操作" width="120" show-overflow-tooltip>
        <template slot-scope="scope">

          <el-button :disabled="formInline.isRecharge != 1" type="primary" @click="handelSJ(scope.row)" size="mini">收据</el-button>
        </template>
      </el-table-column>




    </el-table>
    <!-- 分页组件 -->
    <Pagination v-if="showPage" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>






    <!-- 单独打印 -->
    <el-dialog title="收据" :visible.sync="shoujuVisbel" width="1040px" :close-on-click-modal="false" style="border: 0;">
      <div class="sj-container djj" ref="printp" style="border: 0; width: 100%;" >
        <div class="sj-header">
          <h3>
            <p>大京九塑胶城管理处收款收据</p>
            <span class="line"></span>
          </h3>
          <!-- <div class="sj-no">凭证号码：<span style="color: red; letter-spacing: 4px;">{{sjNo}}</span></div> -->
        </div>
        <div class="sj-detail">
          <div class="">
            <p>商铺名称:{{formDjj.walletName}}</p>
            <p>客户名称:{{formDjj.appletName}}</p>
          </div>
          <div class="">
            <p class="sj-date">填票日期：{{sjDate.yyyy}} 年 {{sjDate.mm}} 月 {{sjDate.dd}} 日</p>
            <!-- <p class="sj-date">填票日期：{{formDjj.createDate.substring(0, 10)}} </p> -->
            <p>NO：{{sjDjj.no}}</p>
          </div>
        </div>

        <div class="sj-content">

          <div class="sj-table">
            <div class="sj-theader">
              <div>充值类目</div>
              <div>充值方式</div>
              <div>充值金额</div>

              <div>当前余额</div>
              <div>充值时间</div>
            </div>
            <div class="sj-tbody">
              <div class="sj-trow">
                <div>水电费</div>
                <div>
                  <span v-if="formDjj.transType == 8">多还少补</span>
                  <span v-if="formDjj.transType == 7">其他</span>
                  <span v-if="formDjj.transType == 6">微信小程序</span>
                  <span v-if="formDjj.transType == 5">微信</span>
                  <span v-if="formDjj.transType == 4">支付宝</span>
                  <span v-if="formDjj.transType == 3">POS</span>
                  <span v-if="formDjj.transType == 2">转账</span>
                  <span v-if="formDjj.transType == 1">现金</span>
                </div>
                <div>{{formDjj.money}}</div>

                <div> {{formDjj.balance}}</div>
                <div>{{formDjj.createDate}}</div>
              </div>
            </div>
          </div>

        </div>
        <div class="sj-ps" style="margin-bottom: 30px;">
          <span>注：白联 存根</span>
          <span>红联 客户</span>
          <span>黄联 记账</span>
          <span style="margin-left: 200px;">17888#</span>
        </div>
        <div class="sj-footer">

          <div class="f-item">
            <div class="w180">
              <span class="kuan"></span>
              <span>复核：{{sjDjj.fh}}</span>
            </div>
            <div style="width: 150px;">
              <span>会计：{{sjDjj.kj}}</span>
            </div>
            <div class="w180">
              <span class="kuan"></span>
              <span>出纳：{{sjDjj.cn}}</span>
            </div>
            <div style="margin-right: 10px;"  >
              <span class="kuan" ></span>
              <span>经手人：{{sjDjj.jsr}}</span>
            </div>
            <div class="flex1" style="text-align: right;">
              <span>大京九塑胶城管理处(盖章)</span>
            </div>
          </div>
        </div>


      </div>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editSj" type="primary">编辑</el-button>
        <el-button size="small" @click="print" type="primary">打印</el-button>
        <el-button size="small" @click="shoujuVisbel = false">取消</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑收据" :visible.sync="editSjVisbel" @click="editSjVisbel = false" width="30%">
      <el-form label-width="100px" :model="sjeditForm" ref="editForm">
        <el-form-item label="出据日期">
          <el-date-picker @change="getSJdate" v-model="sjeditForm.date" value-format="yyyy-MM-dd" type="date" size="small"
            placeholder="选择日期">
          </el-date-picker>

        </el-form-item>
        <el-form-item label="编号">
          <el-input size="small" v-model="sjDjj.no" placeholder="请输入编号"></el-input>
        </el-form-item>
        <el-form-item label="复核">
          <el-input size="small" v-model="sjDjj.fh" placeholder="请输入复核"></el-input>
        </el-form-item>
        <el-form-item label="会计">
          <el-input size="small" v-model="sjDjj.kj" placeholder="请输入会计"></el-input>
        </el-form-item>
        <el-form-item label="出纳" size="small">
          <el-input size="small" v-model="sjDjj.cn" placeholder="请输入出纳"></el-input>
        </el-form-item>
        <el-form-item label="经手人" size="small">
          <el-input size="small" v-model="sjDjj.jsr" placeholder="请输入经手人"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button size="small" type="primary" @click="saveSJ">保存</el-button> -->
        <el-button size="small" @click="editSjVisbel = false">关闭</el-button>
      </div>
    </el-dialog>


    <!-- 批量打印 -->
    <div class="printContainer" style="display: none;">
      <div class="sj-container djj" ref="print" v-for="(item,index) of prints" :key="index" :id="'printDiv' + index"
        style="page-break-after:always;">
        <div class="sj-header">
          <h3>
            <p>大京九塑胶城管理处收款收据</p>
            <span class="line"></span>
          </h3>
          <!-- <div class="sj-no">凭证号码：<span style="color: red; letter-spacing: 4px;">{{sjNo}}</span></div> -->
        </div>
        <div class="sj-detail">
          <div class="">
            <p>商铺名称:{{item.walletName.replace('#1', '').replace('大京九塑胶城四期铺面/','').replace(
            /(^\s*)|(\s*$)/g, "")}}</p>
            <p>客户名称:{{item.appletName}}</p>
          </div>
          <div class="">

            <p class="sj-date">填票日期：{{item.createDate.substring(0, 4)}} 年 {{item.createDate.substring(5, 7)}} 月 {{item.createDate.substring(8, 10)}} 日</p>
            <!-- <p class="sj-date">填票日期：{{formDjj.createDate.substring(0, 10)}} </p> -->
            <p>NO：{{'SY'+item.receiptNo}}</p>
          </div>
        </div>

        <div class="sj-content">
          <div class="sj-table">
            <div class="sj-theader">
              <div>充值类目</div>
              <div>充值方式</div>
              <div>充值金额</div>
              <div>当前余额</div>
              <div>充值时间</div>
            </div>
            <div class="sj-tbody">
              <div class="sj-trow">
                <div>水电费</div>
                <div>
                  <span v-if="item.transType == 8">多还少补</span>
                  <span v-if="item.transType == 7">其他</span>
                  <span v-if="item.transType == 6">微信小程序</span>
                  <span v-if="item.transType == 5">微信</span>
                  <span v-if="item.transType == 4">支付宝</span>
                  <span v-if="item.transType == 3">POS</span>
                  <span v-if="item.transType == 2">转账</span>
                  <span v-if="item.transType == 1">现金</span>
                </div>
                <div>{{item.money}}</div>
                <div> {{item.balance}}</div>
                <div>{{item.createDate}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="sj-ps" style="margin-bottom: 30px;">
          <span>注：白联 存根</span>
          <span>红联 客户</span>
          <span>黄联 记账</span>
          <span style="margin-left: 200px;">17888#</span>
        </div>
        <div class="sj-footer">

          <div class="f-item">
            <div class="w200">
              <span class="kuan"></span>
              <span>复核：{{sjDjj.fh}}</span>
            </div>
            <div style="width: 150px;">
              <span>会计：{{sjDjj.kj}}</span>
            </div>
            <div class="w200">
              <span class="kuan"></span>
              <span>出纳：{{sjDjj.cn}}</span>
            </div>
            <div style="margin-right: 10px;">
              <span class="kuan"></span>
              <span>经手人：{{sjDjj.jsr}}</span>
            </div>
            <div class="flex1" style="text-align: right;">
              <span>大京九塑胶城管理处(盖章)</span>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import html2canvas from 'html2canvas';
  import PremsButton from "@/views/permission/PreButtom1";
  import {
    FindRechargesAndPage,
    exportRecharges
  } from '../../api/payMG'
  import {
    getDepartmentTerminalInfoLis
  } from '../../api/energyMG.js'
  import {
    timestampToTime
  } from '@/utils/util'
  import Pagination from '../../components/Pagination'
  html2canvas(document.body).then(function(canvas) {
    document.body.appendChild(canvas);
  });
  export default {
    data() {
      return {

        showPage: true,
        editSjVisbel: false,
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        payway: [],
        huiZhi: {
          money: "",
          createDate: "",
          payer: "",
          drawee: "",
          payType: "",
          orderNo: "",
        },
        sjDjj: {
          fh: "",
          kj: "",
          cn: "",
          jsr: "",
          no: "",
        },
        formDjj: {},
        user: {},
        sjNo: "",
        dxNum: "",
        sjeditForm: {
          date: "",
          username: "",
          from: "",
          money: ""
        },
        sjDate: {
          yyyy: '',
          mm: "",
          dd: ""
        },
        downloadLoadin: false,
        downloadJlLoadin: false,
        showJ: false,
        shoujuVisbel: false,
        payType: [{
            lable: '充值',
            value: 1
          },
          {
            lable: '扣费',
            value: 2
          },
          {
            lable: '退款',
            value: 3
          }
        ],
        setLoading: false,
        formInline: {
          currentPage: 1,
          pageSize: 10,
          appletUserName: '',
          isRecharge: 1,
          depId: "",
          startDate: '',
          endDate: '',
        },

        screenshotImage: "",
        imgUrl: "",
        listData: [],
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        tableHeight: 0,
        exportParam: {
          startTime: timestampToTime(new Date()).substring(0, 10),
          endTime: timestampToTime(new Date()).substring(0, 10),

        },
        prints: [],
        dataStr: [],
        deptList: [],
        tableData: [{
          id: '电费',
          name: '公众号',
          amount1: '100',
          amount2: '21',
          amount3: '121',
          amount4: '2021-09-01 08:12:10'
        }]
      }
    },
    // 注册组件
    components: {
      Pagination,
      PremsButton
    },
    /**
     * 数据发生改变
     */

    mounted() {
      this.$nextTick(() => {

        this.tableHeight = window.innerHeight - 300
      })
    },
    created() {

      this.user = JSON.parse(sessionStorage.getItem('userdata'))
      if (this.user.username != 'admin') {

        this.formInline.depId = this.user.departmentId

        this.getdata();
      } else {
        //管理员登录
        this.getJzData().then(res => {
          this.formInline.depId = res.id
          this.getdata();
        });
      }

      this.sjDjj.fh = ""
      this.sjDjj.kj = "吴小慧"
      this.sjDjj.cn = "万湘林"
      this.sjDjj.jsr = "微信自助充值"
    },

    /**
     * 里面的方法只有被调用才会执行
     */

    filters: {
      payWay(val) {
        if (val == 1) {
          return '现金'
        } else if (val == 2) {
          return '转账'
        } else if (val == 3) {
          return 'POST'
        } else if (val == 4) {
          return '支付宝'
        } else if (val == 5) {
          return '微信'
        } else if (val == 6 || val == 0) {
          return '其他'
        } else {
          return '多还少补'
        }
      }
    },
    methods: {

      selectionChange(e) {
        this.prints = e

      },

      handlePrint() {

        var newWin = window.open(""); //新打开一个空窗口
        for (var i = 0; i < this.prints.length; i++) {
          var imageToPrint = document.getElementById("printDiv" + i); //获取需要打印的内容
           console.log(imageToPrint)
           newWin.document.write(imageToPrint.outerHTML); //将需要打印的内容添加进新的窗口
        }

        const styleSheet =
          `<style>
        									.sj-detail {
        									  display: flex;
        									  justify-content: space-between;
        									  font-size: 20px;
        									  line-height: 10px;
        									}
        									.sj-container.djj {
        									  width: 1000px;
        									  height: 410px;
                            margin:0 auto;
        									  color: #000000;
        									  overflow: hidden;
        									  padding: 0;
        									}
        									.sj-container.djj .sj-header {
        									  text-align: center;
        									  font-size: 26px;
        									  margin-bottom: 12px;
        									  position: relative;
        									}
        									.sj-container.djj .sj-header .sj-no {
        									  font-size: 20px;
        									  position: absolute;
        									  top: 40px;
        									  right: 42px;
        									}
        									.sj-table{
        									  border: 1px solid #000;
        									  font-size: 20px;
        									}
        									.sj-container.djj .sj-header h3{
        									  display: inline-block;
        									  margin: 0 auto;
        									  padding: 30px 20px 4px 20px;
        									  width: auto;
        									  border-bottom: 3px solid #000000;
        									  position: relative;
        									}
        									.sj-container.djj .sj-header h3 p {
        									  margin: 0;
        									}
        									.sj-container.djj .sj-header h3.line {
        									  height: 2px;
        									  position: absolute;
        									  bottom: -6px;
        									  left: 0;
        									  width: 100%;
        									  border-bottom: 1px solid #000000;
        									}
        									.sj-container.djj .sj-content {
        									  position: relative;
        									  padding: 20px 0 40px 0;
        									  margin: 0 auto;
        									}
                          .sj-container.djj .sj-footer{
                            font-size: 15px;
                          }
        									.sj-container.djj .sj-silde {
        									  position: absolute;
        									  width: 20px;
        									  right: -30px;
        									  top: 10px;
        									}
        									.sj-container.djj .sj-content p
                          {
        									  margin: 0;
        									}
        									.sj-container.djj .f-item {
        									  display: flex;
        									  margin-bottom: 20px;
        									}
        									.sj-container.djj .f-item .w200{
        									  width: 198px;
        									}
        									.sj-container.djj .f-item .flex1 {
        									  flex: 1;
        									}
        									.sj-ps span {
        									  padding-right: 40px;
        									  font-size:15px;
        									}
        									.sj-theader, .sj-trow{
        									  display: flex;
        									  line-height: 50px;
        									}
        									.sj-theader div{
        									  flex: 1;
        									  border-bottom: 1px solid #000;
        									  padding-left:10px;
        									  color: #000;
        									  border-right: 1px solid #000;
        									}
        									.sj-trow div{
        									  flex: 1;
        									  padding-left:10px;
        									  font-size: 18px;
        									   border-right: 1px solid #000;
        									   color: #000;
        									}
        									.sj-theader div:last-child{
        									  border-right: 0;
        									}
        									.sj-trow div:last-child{
        									  border-right: 0;
        									}

        								</style>`;
        newWin.document.head.innerHTML = styleSheet; //给打印的内容加上样式
        newWin.document.close(); //在IE浏览器中使用必须添加这一句
        newWin.focus(); //在IE浏览器中使用必须添加这一句
        setTimeout(function() {
          newWin.print(); //打印
          newWin.close(); //关闭窗口
        }, 100);
      },


      getJzData: function() {
        return new Promise((resolve, reject) => {
          getDepartmentTerminalInfoLis().then(res => {
            this.treeLoad = false
            if (res.status == 1) {
              let arr = []
              this.deptList = res.data.menuDepList
              res.data.terIds.forEach(item => {
                arr.push({
                  id: item
                })
              })
              resolve(this.deptList[0])

            } else {
              this.$message.error(res.msg)
            }
          })
        })

      },


      randomn(n) {
        if (n > 21) return null
        return parseInt((Math.random() + 1) * Math.pow(10, n - 1))
      },


      saveSJ() {},

      editSj() {
        this.editSjVisbel = true
      },
      print() {
        this.$print(this.$refs.printp)

        // this.prints = []
        // this.prints.push(this.formDjj)
        // this.$nextTick(() => {
        //    this.handlePrint()
        // })

      },

      getSJdate() {
        this.sjDate.yyyy = this.sjeditForm.date.substring(0, 4)
        this.sjDate.mm = this.sjeditForm.date.substring(5, 7)
        this.sjDate.dd = this.sjeditForm.date.substring(8, 10)

      },

      handelSJ(row) {
        this.shoujuVisbel = true
        this.sjNo = this.randomn(6)
        this.sjeditForm.username = row.appletUserNames
        this.sjeditForm.from = row.meterPointName + '充值'
        this.sjeditForm.money = row.money





        let param = {
          accountId: row.id
        }
        this.formDjj = row
        if (this.formDjj.walletName) {
          this.formDjj.walletName = this.formDjj.walletName.replace('#1', '').replace('大京九塑胶城四期铺面/','').replace(
            /(^\s*)|(\s*$)/g, "");
        }




        this.sjDate.yyyy = this.formDjj.createDate.substring(0, 4)
        this.sjDate.mm = this.formDjj.createDate.substring(5, 7)
        this.sjDate.dd = this.formDjj.createDate.substring(8, 10)
        this.sjeditForm.date = this.formDjj.createDate.substring(0, 10)

        this.sjDjj.no = 'SY' + row.receiptNo


      },




      showHuiZhi(id) {
        this.editFormVisible = true
        let params = {
          accountId: id,
          dealTtype: 1
        }
        findTradeReceiptByAccountId(params).then(res => {
          if (res.status == 1) {
            if (res.data.imgPath) {
              let tempArr = JSON.parse(res.data.imgPath)
              this.imgUrl = tempArr[0].url
            }
            if (res.data.data[0]) {
              this.huiZhi.money = res.data.data[0].money
              this.huiZhi.createDate = res.data.data[0].createDate
              this.huiZhi.payer = res.data.data[0].payer
              this.huiZhi.drawee = res.data.data[0].drawee
              this.huiZhi.payType = res.data.data[0].payType
              this.huiZhi.orderNo = res.data.data[0].orderNo

            } else {
              this.huiZhi.money = '--'
              this.huiZhi.createDate = '--'
              this.huiZhi.payer = '--'
              this.huiZhi.drawee = '--'
              this.huiZhi.payType = 0
              this.huiZhi.orderNo = '--'
            }

          }

        })
      },

      async toImage() {
        this.setLoading = true
        const opts = {

        }
        html2canvas(this.$refs.imageDom, {
          backgroundColor: '#ffffff',
          useCORS: true,

        }).then(canvas => {
          // this.screenshotImage = canvas.toDataURL('image/jpg')
          var imgData = canvas.toDataURL("image/jpeg");
          this.setLoading = false
          this.fileDownload(imgData);

        })

      },
      fileDownload(downloadUrl) {
        let aLink = document.createElement("a");
        aLink.style.display = "none";
        aLink.href = downloadUrl;
        aLink.download = "回执.png";
        // 触发点击-然后移除
        document.body.appendChild(aLink);
        aLink.click();
        document.body.removeChild(aLink);
      },

      exportdata() {
        this.downloadLoadin = true
        let param = { ...this.exportParam,
          meterPointName: this.formInline.meterPointName
        }
        poiAccountList(param).then(res => {

          var blob = new Blob([res], {
            type: 'application/vnd.openxmlformats-  officedocument.spreadsheetml.sheet;charset=utf-8'
          }); //type这里表示xlsx类型
          var downloadElement = document.createElement('a');
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = '交易记录.xls'; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
          this.downloadLoadin = false
          this.$message.success('表格生成成功！正在下载')
        }).catch(err => {
          this.downloadLoadin = false
          this.$message({
            message: '下载失败！',
            type: 'error',
            showClose: true
          })
        })

      },

      exportJldata() {
        this.downloadJlLoadin = true

        let param = {
          appletUserName: this.formInline.appletUserName,
          isRecharge: this.formInline.isRecharge,
          startDate: this.formInline.startDate,
          endDate: this.formInline.endDate,
          depId: this.formInline.depId
        }

        exportRecharges(param).then(res => {


          var blob = new Blob([res], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
          }); //type这里表示xlsx类型
          var downloadElement = document.createElement('a');
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = '交易记录.xls'; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
          this.downloadJlLoadin = false
          this.$message.success('表格生成成功！正在下载')
        }).catch(err => {
          this.downloadJlLoadin = false
          this.$message({
            message: '下载失败！',
            type: 'error',
            showClose: true
          })
        })
      },
      getdata() {
        this.loading = true
        FindRechargesAndPage(this.formInline)
          .then(res => {
            this.loading = false
            if (res.status == 1) {
              this.listData = res.data.data
              // 分页赋值
              this.pageparm.currentPage = this.formInline.currentPage
              this.pageparm.pageSize = this.formInline.pageSize
              this.pageparm.total = res.data.totalCount
              this.$nextTick(() => {
                this.showJ = this.formInline.isRecharge === 2
              })

            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('数据加载失败，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.currentPage = parm.currentPage
        this.formInline.pageSize = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.pageparm.currentPage = 1
        this.formInline.currentPage = 1
        this.showPage = false;
        this.getdata(this.formInline)
        this.$nextTick(() => {
          this.showPage = true
        })
      },

      tableRowClassName({
        row,
        rowIndex
      }) {
        if (rowIndex === 1) {
          return 'warning-row';
        } else if (rowIndex === 3) {
          return 'success-row';
        }
        return '';
      },
      getDate(val) {
        // this.exportParam.startTime = timestampToTime(this.dataStr[0]).substring(0, 10)
        // this.exportParam.endTime = timestampToTime(this.dataStr[1]).substring(0, 10)
        this.formInline.startDate = timestampToTime(this.dataStr[0]).substring(0, 10)
        this.formInline.endDate = timestampToTime(this.dataStr[1]).substring(0, 10)

        this.search()

      }


    }
  }
</script>

<style scoped>
  .sj-detail {
    display: flex;
    justify-content: space-between;
    font-size: 20px;
    line-height: 10px;
  }

  .sj-container.djj {
    width: 1000px;
    height: 410px;
    color: #000000;
    overflow: hidden;
    padding: 0;

  }

  .sj-container.djj .sj-header {
    text-align: center;
    font-size: 26px;
    margin-bottom: 12px;
    position: relative;

  }

  .sj-container.djj .sj-header .sj-no {
    font-size: 20px;
    position: absolute;
    top: 40px;
    right: 42px;
  }

  .sj-container.djj .sj-header h3 {
    display: inline-block;

    margin: 0 auto;

    padding: 30px 20px 4px 20px;
    width: auto;
    border-bottom: 3px solid #000000;
    position: relative;

  }

  .sj-container.djj .sj-header h3 p {
    margin: 0;
  }

  .sj-container.djj .sj-header h3 .line {

    height: 2px;
    position: absolute;
    bottom: -6px;
    left: 0;
    width: 100%;
    border-bottom: 1px solid #000000;
  }

  .sj-container.djj .sj-content {
    position: relative;
    padding: 20px 0 40px 0;
    margin: 0 auto;

  }

  .sj-container.djj .sj-silde {
    position: absolute;
    width: 20px;
    right: -30px;
    top: 10px;
  }

  .sj-date {}

  .sj-container.djj .sj-content p {
    margin: 0;
  }

  .sj-container.djj .f-item {
    display: flex;

    margin-bottom: 20px;
  }

  .sj-container.djj .f-item div {}

  .sj-container.djj .f-item .w200 {
    width: 198px;
  }

  .sj-container.djj .f-item .flex1 {
    flex: 1;
  }

  .sj-ps span {
    padding-right: 40px;
    font-size: 15px;
    /* font-weight: bold; */
  }

  .input-item {
    font-size: 20px;
    display: flex;
    line-height: 32px;
    margin-bottom: 20px;
  }

  .i-lable {
    width: 80px;
  }

  .i-value {
    border-bottom: 1px solid #000000;
    width: 100%;
    position: relative;
  }

  .i-value .num {
    position: absolute;
    right: 0;
  }
  .w180{
    width: 180px;
  }



  .sj-container.djj .sj-footer {
    width: 1000px;
    font-size: 15px;
    overflow: hidden;
    /* font-weight: bold; */
  }



  .userRole {
    width: 100%;
  }

  .h-container {
    width: 560px;

    padding: 0;
    background: url(../../assets/img/hbg.png);
  }

  .h-header {
    padding: 20px 0;
    border-bottom: 1px solid #e4e4e4;
  }

  .h-header .h-title {
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    color: #000000;
  }

  .h-header p {
    padding: 0 20px;

    font-size: 18px;
    color: #999999;
    text-align: center;
    line-height: 30px;
    letter-spacing: 4px;

    margin: 10px auto;
  }

  .h-main {
    padding: 30px 40px;
    border-bottom: 1px solid #e4e4e4;
    position: relative;
  }

  .zhang {
    position: absolute;
    bottom: 20px;
    right: 20px;
    opacity: 0.8;
    width: 240px;
  }

  .h-item {
    display: flex;
    font-size: 16px;
  }

  .item-t {
    width: 252px;
    color: #333333;
  }

  .h-footer {
    padding: 30px 40px;
    display: flex;
  }

  .h-footer p {
    font-size: 20px;

    margin-left: 10px;
  }

  .sj-table {
    border: 1px solid #000;
    font-size: 20px;
    /* font-weight: bold; */
  }

  .sj-theader,
  .sj-trow {
    display: flex;
    line-height: 50px;
  }

  .sj-theader div {
    flex: 1;
    border-bottom: 1px solid #000;
    padding-left: 10px;
    color: #000;
    /* font-weight: bold; */
    border-right: 1px solid #000;
  }

  .sj-trow div {
    flex: 1;
    padding-left: 10px;
    font-size: 18px;
    border-right: 1px solid #000;
    color: #000;
  }

  .sj-theader div:last-child {
    border-right: 0;
  }

  .sj-trow div:last-child {
    border-right: 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/account/accountOrder.vue